require('./angular-resource');
module.exports = 'ngResource';



//////////////////
// WEBPACK FOOTER
// ./~/angular-resource/index.js
// module id = 364
// module chunks = 1